import type { BadgeTone } from "./Badge";

const TONE_DOT: Record<BadgeTone, string> = {
  good: "bg-signal-good",
  warn: "bg-signal-warn",
  bad: "bg-signal-bad",
  neutral: "bg-signal-neutral",
  accent: "bg-accent-500",
};

export function StatusDot({ tone = "neutral", label }: { tone?: BadgeTone; label: string }) {
  return (
    <span className="inline-flex items-center gap-1.5" title={label}>
      <span className={`h-2 w-2 rounded-full ${TONE_DOT[tone]}`} aria-hidden="true" />
      <span className="text-sm text-ink-600">{label}</span>
    </span>
  );
}
